// FieldError.tsx
import React from "react";

interface FieldErrorProps {
    show: boolean;
    message: string;
}

const FieldError: React.FC<FieldErrorProps> = ({ show, message }) => {
    return show ? (
        <div
            style={{
                width: "100%",
                marginTop: "0.25rem",
                fontSize: "80%",
                color: "#f46a6a",
            }}
        >
            {message}
        </div>
    ) : null;
};

export default FieldError;
